module.exports = __webpack_public_path__ + "c50ababec24a658ee5da1a7285a35c53.svg";